import React from "react";

interface TextAreaFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  rows?: number;
  required?: boolean;
  touched?: boolean;
  error?: string;
  className?: string;
  textareaClassName?: string;
  maxLength?: number;
  minLength?: number;
}

const TextAreaField: React.FC<TextAreaFieldProps> = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  rows = 4,
  required = false,
  touched = false,
  error,
  className = "",
  textareaClassName = "",
  maxLength,
  minLength,
}) => {
  return (
    <div className={className || undefined}>
      <label className="block f-16 font-weight-300 text[#989898] mb-4">
        {label} {required && <span className="text-red-400">*</span>}
      </label>
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        minLength={minLength}
        aria-describedby={maxLength ? `${name}-char-count` : undefined}
        className={`w-full px-4 py-3 border-2 rounded-[27px] text-white bg-transparent focus:ring-2 focus:ring-[#E761A0]/50 focus:outline-none transition-all duration-200 placeholder-gray-500 resize-none ${textareaClassName} ${
          touched && error
            ? "border-red-500/50 bg-red-500/10"
            : "border-[#E761A0] hover:border-[#E761A0]"
        }`}
      />
      {maxLength != null && (
        <p
          id={`${name}-char-count`}
          className="mt-1 text-sm text-gray-500"
          aria-live="polite"
        >
          {value.length} / {maxLength} characters
        </p>
      )}
      {touched && error && (
        <p className="mt-2 text-sm text-red-400 flex items-center gap-1">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
          {error}
        </p>
      )}
    </div>
  );
};

export default TextAreaField;
